import React from "react";
import { MdHelp } from "react-icons/md";
import { t } from "i18next";


const ConfirmIcon = () => <MdHelp className="w-16 h-16 text-primary" />;

export const getConfirmDialogProps = (props) => ({
  className: "border-t-4 border-primary-hover",
  titleClassName: "text-primary-hover",
  textClassName: "text-primary",
  image: props.image || <ConfirmIcon />,
  buttons: props.buttons || [
    {
      text: t("general.buttons.confirm"),
      variant: "primary",
      action: props.onConfirm,
    },
    {
      text: t("general.buttons.cancel"),
      variant: "secondary",
      action: props.onCancel,
    },
  ],
  ...props,
});

export default ConfirmIcon;
